import { render, staticRenderFns } from "./FormCrudMandrel.vue?vue&type=template&id=a16113e4"
import script from "./FormCrudMandrel.vue?vue&type=script&lang=js"
export * from "./FormCrudMandrel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports